
import Cookies from 'universal-cookie';

export default {
  name: 'CookieCustomizationModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isModalOpen: false,
      cookiePreferences: {
        technical: true,        // Always required - GTM, basic functionality
        analytics: false,       // Google Analytics, performance tracking
        marketing: false,       // Facebook Pixel, Google Ads, remarketing
        experience: false       // Hotjar, Microsoft Clarity, UX analysis
      }
    }
  },
  methods: {
    close() {
      this.isModalOpen = false;
      this.$emit('close');
    },
    savePreferences() {
      // Save to cookies instead of session for persistence
      const cookies = new Cookies();

      cookies.set('cookie_preferences', this.cookiePreferences, {
        path: '/',
        maxAge: 6 * 30 * 24 * 60 * 60, // 6 months
        sameSite: 'lax'
      });
      cookies.set('cookie_accepted', true, {
        path: '/',
        maxAge: 6 * 30 * 24 * 60 * 60, // 6 months
        sameSite: 'lax'
      });

      // Update consent through Analytics Manager (handles GTM and all providers)
      this.updateAnalyticsConsent();

      this.$emit('preferences-saved', this.cookiePreferences);

      this.close();
    },
    updateAnalyticsConsent() {
      // Update consent through Analytics Manager (handles all providers including GTM)
      if (typeof window !== 'undefined' && window.$analytics) {
        // Update consent for all providers
        window.$analytics.updateConsent(this.cookiePreferences);

        // Track consent change event
        window.$analytics.track('consent_updated', {
          consent_preferences: this.cookiePreferences,
          analytics_allowed: this.cookiePreferences.analytics,
          marketing_allowed: this.cookiePreferences.marketing,
          experience_allowed: this.cookiePreferences.experience
        });
      }

      // Store consent globally for providers to check
      window.analyticsConsent = {
        analytics: this.cookiePreferences.analytics,
        marketing: this.cookiePreferences.marketing,
        experience: this.cookiePreferences.experience,
        technical: this.cookiePreferences.technical,
        timestamp: Date.now()
      };
    }
  },
  watch: {
    isOpen(val) {
      this.isModalOpen = val;
      if (val) {
        // Load existing preferences from cookies
        const cookies = new Cookies();
        const existingPrefs = cookies.get('cookie_preferences');
        if (existingPrefs) {
          this.cookiePreferences = { ...existingPrefs };
        }
      }
    }
  }
}
